import PropTypes from 'prop-types';
import React from 'react';
import Image from 'components/Image';
import Video from 'components/Video';

const Asset = ({ asset }) => {
  if (asset.type === 'Video') {
    let sources = [];
    if (asset.provider && asset.basename) {
      sources = asset.basename;
    } else if (asset.hlsPlaylistUrl) {
      sources = asset.hlsPlaylistUrl;
    } else {
      if (asset.mp4Url) {
        sources.push({
          src: asset.mp4Url,
          type: 'video/mp4',
        });
      }
      if (asset.webmUrl) {
        sources.push({
          src: asset.webmUrl,
          type: 'video/webm',
        });
      }
    }
    return <Video sources={sources} />;
  }
  return (
    <Image
      alt={asset.description}
      src={asset.url}
    />
  );
};

Asset.propTypes = {
  asset: PropTypes.object.isRequired,
};

export default Asset;
